import { z } from "zod/v4";

import { StripeProductVersionList } from "../../schemas/stripe";

export const StripeApiProductDtoSchema = z.object({
  id: z.string(),
  name: z.string(),
  description: z.string().nullish(),
  version: z.enum(StripeProductVersionList),
});

export type StripeApiProductDto = z.infer<typeof StripeApiProductDtoSchema>;
